<template>
    <diaLog tit="次数不足" ref="dialog" width="500px" @handleClose="handleClose" :footerShowState="false">
        <div>{{ text }}</div>
        <div class="btnBox">
            <el-button class="btn" @click="homeInfoClose">不再提醒</el-button>
            <el-button type="primary" class="btn" @click="topUp">去充值</el-button>
        </div>
    </diaLog>
</template>

<script>
import diaLog from '@/components/diaLog'
import SponsorService from '@/services/user/sponsor';
export default {
    components: { diaLog },
    data() {
        return {
            text: ''
        }
    },
    methods: {
        getText(text) {
            this.text = text
        },
        homeInfoClose() {
            SponsorService.homeInfoClose()
            this.handleClose()
        },
        handleClose() {
            this.$emit('lackTipclose')
        },
        topUp() {
            this.$emit('topUp')
        }
    },
}
</script>

<style lang="scss" scoped>
.btnBox{
    margin-top: 20px;
    text-align: center;
}
</style>
